import { useLocation, useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton } from "@mui/material";
import { formatDubaiDateTime } from "../../utils/dateTime";

const ViewSubscription = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;

  const goBack = () => {
    navigate(-1);
  };
  const subscriptionData = [
    {
      id: 1,
      name: "John Doe",
      image: "/static/images/placeholder.png",
      email: "john@example.com",
      membership: "Single",
      date: "2025-07-01",
    },
    {
      id: 2,
      name: "Jane Smith",
      image: "/static/images/placeholder.png",
      email: "jane@example.com",
      membership: "Duo",
      date: "2025-07-03",
    },
    {
      id: 3,
      name: "Michael Johnson",
      image: "/static/images/placeholder.png",
      email: "michael@example.com",
      membership: "Single",
      date: "2025-07-05",
    },
    {
      id: 4,
      name: "Emily Davis",
      image: "/static/images/placeholder.png",
      email: "emily@example.com",
      membership: "Duo",
      date: "2025-07-07",
    },
  ];
  return (
    <>
      <MainContainer>
        <div className="main_title">
          <h1 className="back_arrow">
            {" "}
            <IconButton onClick={() => goBack()}>
              {" "}
              <ArrowBackIcon />{" "}
            </IconButton>{" "}
            View Subscription
          </h1>
        </div>

        <div className="cards view_page">
          <div className="section_sub_title mb_30">
            <figure>
              <img alt="user" src="/static/images/duo_icon.svg" />
            </figure>{" "}
            <h3> {`${state?.data?.memberShipType} Membership`}</h3>
          </div>

          <div className="gap_p ">
            <div className="w_25">
              <h6>Payment Method</h6>
              <p> {state?.data?.memberShipPlan || "-"}</p>
            </div>
            <div className="w_25">
              <h6>Created Date</h6>
              <p>
                {state?.data?.createAt
                  ? formatDubaiDateTime(state?.data?.createAt)
                  : "-"}
              </p>
            </div>
            <div className="w_25">
              <h6>Price</h6>
              <p>{`AED ${state?.data?.price || "0"}`}</p>
            </div>
            <div className="w_100">
              <h6>Description</h6>
              <p>{state?.data?.description || "-"}</p>
            </div>
          </div>
        </div>
        {/* <div className="cards view_page">
          <div className="section_sub_title mb_30">
            <h3>Subscription History</h3>
          </div>
          <div className="table_container">
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th>User Details</th>
                  <th>Email</th>

                  <th>Subscription Date</th>
                </tr>
              </thead>
              <tbody>
                {subscriptionData.map((user) => (
                  <tr key={user.id}>
                    <td
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <img
                        src={user.image}
                        alt={user.name}
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "50%",
                          objectFit: "cover",
                        }}
                      />
                      {user.name}
                    </td>
                    <td>{user.email}</td>

                    <td>{user.date}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div> */}
      </MainContainer>
    </>
  );
};

export default ViewSubscription;
